import styled from "styled-components";

const EmptySpace = styled.div`
    height: 400px;
    width: 100%;
    /* background-color: red; */
`;

export default EmptySpace;
